module.exports = __webpack_public_path__ + "img/材料力学1_5_3.1414e469.jpg";